(() => {
  const root = document.querySelector('[data-mw-faq]');
  if (!root) return;
  const input = root.querySelector('[data-faq-search]');
  const filters = [...root.querySelectorAll('[data-filter]')];
  const content = root.querySelector('[data-faq-content]');
  const status = root.querySelector('[data-faq-status]');
  const empty = root.querySelector('[data-faq-empty]');
  if (!input || !content) return;

  const groups = [...content.querySelectorAll('.mw-faq-group')];
  const items = [...content.querySelectorAll('.mw-faq-item')];
  const total = root.querySelector('[data-faq-total]');
  if (total) total.textContent = String(items.length);

  // Rebuild searchable text from the editable Shopify page itself.
  items.forEach((item, index) => {
    const group = item.closest('.mw-faq-group');
    const category = item.dataset.category || group?.dataset.category || '';
    item.dataset.category = category;
    item.dataset.searchIndex = item.textContent || '';
    if (!item.id) item.id = `faq-answer-${index + 1}`;
  });

  let category = 'all';
  const norm = value => (value || '').toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim();

  function apply() {
    const q = norm(input.value);
    let shown = 0;
    items.forEach(item => {
      const okCat = category === 'all' || item.dataset.category === category;
      const okSearch = !q || norm(item.dataset.searchIndex).includes(q);
      item.hidden = !(okCat && okSearch);
      if (!item.hidden) shown += 1;
      if (q && okCat && okSearch) item.open = true;
    });
    groups.forEach(group => {
      group.hidden = ![...group.querySelectorAll('.mw-faq-item')].some(item => !item.hidden);
    });
    if (empty) empty.hidden = shown !== 0;
    if (status) status.textContent = (q || category !== 'all') ? `${shown} ${shown === 1 ? 'answer' : 'answers'} found` : '';
  }

  input.addEventListener('input', apply);
  root.querySelector('[data-faq-submit]')?.addEventListener('click', () => { apply(); input.focus(); });
  input.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    input.value = '';
    category = 'all';
    filters.forEach(button => {
      const active = button.dataset.filter === 'all';
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    apply();
    input.blur();
  });
  filters.forEach(button => button.addEventListener('click', () => {
    category = button.dataset.filter || 'all';
    filters.forEach(other => {
      const active = other === button;
      other.classList.toggle('is-active', active);
      other.setAttribute('aria-pressed', String(active));
    });
    apply();
  }));

  const openHash = () => {
    if (!location.hash) return;
    const el = document.querySelector(location.hash);
    if (el?.matches('.mw-faq-item')) {
      el.hidden = false;
      el.open = true;
      requestAnimationFrame(() => el.scrollIntoView({ block: 'start' }));
    }
  };
  window.addEventListener('hashchange', openHash);
  apply();
  openHash();
})();
